import React, { Component } from 'react'
import PropTypes from 'prop-types'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import RecomendedNg from './../block/RecomendedNg'
import FeedbackForm from './../block/FeedbackForm'

import { Container, Row, Col, Image, Form, Button } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      summ: 0,
      show: false
    }
  }

  handleShow() {
    this.setState({
      show: true
    })
  }
  handleClose = () => {
    this.setState({
      show: false
    })
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  changeSum( sum ) {
    this.setState({
      summ: isNaN( sum ) ? 20000 : Number( sum )
    })
  }

  buyVirtual() {
    const { addTocart } = this.props,
    { summ } = this.state

    addTocart({
      resource: 16162,
      product: 16162,
      variant: summ,
      count: 1
    })
  }
  buyFiz() {
    const { addTocart } = this.props,
    { summ } = this.state

    addTocart({
      resource: 16163,
      product: 16163,
      variant: summ,
      count: 1
    })
  }

  componentDidMount() {
    const { ajax_data } = this.props

    if('summi' in ajax_data) {
      this.setState({
        summ: ajax_data.summi[0]
      })
    }
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, showInCart, favorite, cart, in_cart_loading, changeFavorite } = this.props,
    { summ, show } = this.state

    var in_arr = false

    return (
      <>
        <HeaderPage
          ajax_data={ajax_data}
          page_data={page_data}
          changeTopSearch={changeTopSearch}
          changeLeftMenuh={changeLeftMenuh}
          favorite={favorite}
          cart={cart}
        />
        <Breadcrumbs
          pages={[
            {
              name: `Подарочная карта`,
              current: true
            }
          ]}
        />
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <div className={styles.podarochnaya_karta}>
              <Container>
                <Row>
                  <Col xl={6}>
                    <Image className={styles.podarochnaya_karta_image + ` d-none d-sm-block`} src={ajax_data.image} width="691" height="770" />
                    <Image className={styles.podarochnaya_karta_image + ` d-sm-none`} src={ajax_data.image_mob} width="355" height="512" />
                  </Col>
                  <Col xl={6}>
                    <div className={styles.podarochnaya_karta_content}>
                      <div style={{ flex: 1 }}>
                        <div className={styles.podarochnaya_karta_srok}>Срок действия: 1 год с момента активации</div>
                        <div dangerouslySetInnerHTML={{__html: ajax_data.introtext}} className={styles.podarochnaya_karta_introtext} />
                        <div className={styles.podarochnaya_karta_summi_title}>Выберите или введите сумму</div>
                        {'summi' in ajax_data &&
                          <div className={styles.podarochnaya_karta_summi}>
                            {ajax_data.summi.map( ( sum, k ) => {
                              if( summ == sum ) in_arr = true
                              return (
                                <div onClick={() => this.changeSum( sum )} className={summ == sum ? styles.podarochnaya_karta_summi_el_active : styles.podarochnaya_karta_summi_el} key={k}>{this.priceFormat(sum)}</div>
                              )
                            })}
                          </div>
                        }
                        <Form.Control onChange={( e ) => this.changeSum( e.target.value )} className={styles.podarochnaya_karta_input} type="text" placeholder="Введите любую сумму от 20 000 ₽" value={in_arr ? `` : summ} />
                        <div className={styles.podarochnaya_karta_text_title}>Описание</div>
                        <div className={styles.podarochnaya_karta_text} dangerouslySetInnerHTML={{__html: ajax_data.content}} />
                      </div>
                      <div className='w-100'>
                        {summ >= 20000 &&
                          <>
                            <Button onClick={() => this.handleShow()} className={styles.block_product_start_buttons_buy + ` w-100 mb-2 d-none`} variant='dark'>
                              <div>Купить подарочную карту</div>
                              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </Button>
{/*
                            <p>Скоро на сайте!</p>
                                                        */}
                            <div className='d-flex flex-column flex-md-row gap-1 mb-2'>
                              <Button onClick={() => this.buyVirtual()} className={styles.block_product_start_buttons_buy + ` w-100 mb-2`} variant='dark'>
                                <div>Купить виртуальную подарочную карту</div>
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </Button>
                              <Button onClick={() => this.buyFiz()} className={styles.block_product_start_buttons_buy + ` w-100 mb-2`} variant='dark'>
                                <div>Купить физическую подарочную карту</div>
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </Button>
                            </div>
                          </>
                        }
                        {page_data.tg &&
                          <div className='w-xl-50 d-flex align-items-center'>
                            <div className={styles.block_product_start_svaz}>
                              Возникли вопросы? Свяжитесь с нами<br />
                              по номеру телефона или в Telegram
                            </div>
                            <a href={page_data.tg} target="_blak" className={styles.block_product_start_svaz_btn}>
                              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
                              </svg>
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          }
        </div>
        <RecomendedNg
          title={`НОВЫЕ ПОСТУПЛЕНИЯ`}
          text={`Посмотрите наши последние поступления дизайнерской одежды и подберите свой стиль`}
          showInCart={showInCart}
          in_cart_loading={in_cart_loading}
          favorite={favorite}
          changeFavorite={changeFavorite}
          cart={cart}
          link={page_data.new_link}
          variant={`new`}
          start={ajax_data?.new_products || { page: 1, paginator: [], products: [] }}
        />
        <FeedbackForm
          title={`Купить подарочную карту`}
          text={``}
          btn={``}
          data={[
            {
              name: `Сумма подарочной карты`,
              value: summ
            }
          ]}
          show={show}
          handleClose={this.handleClose}
        />
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool,
  addTocart: PropTypes.func
}